import { Badge as ChakraBadge } from "@chakra-ui/react"
import React from "react"

interface Props {
  text: string
  bg?: string
  color?: string
  fontSize?: string
  border?: string
}

const Badge: React.FC<Props> = ({
  text,
  bg = "#38A169",
  color = "white",
  fontSize = "xs",
  border = "none",
}) => {
  return (
    <ChakraBadge
      colorScheme="primary"
      padding="0.35em 0.5em"
      fontWeight="600"
      borderRadius="5px"
      whiteSpace="nowrap"
      lineHeight="1"
      textTransform="none"
      color={color}
      bg={bg}
      fontSize={fontSize}
      border={border}
    >
      {text}
    </ChakraBadge>
  )
}

export default Badge
